// Reveal-on-scroll. Adds `.is-revealed` to `[data-reveal]` when it enters view.
// Honors prefers-reduced-motion (reveals immediately). Idempotent per element.
//
// After the reveal transition finishes, the reveal hooks (`data-reveal` attribute +
// `.is-revealed` class) are removed so the reveal's `transform: none` can never
// fight a component's `:hover` transform (e.g. a card lift). Once shown, the element
// keeps its default visible state, so removal causes no visual change.

function cleanup(el) {
  el.removeAttribute("data-reveal");
  el.classList.remove("is-revealed");
  el.style.transitionDelay = "";
  el.style.willChange = "";
}

function reveal(el) {
  const delay = parseInt(el.getAttribute("data-reveal-delay") || "0", 10);
  if (delay) el.style.transitionDelay = `${delay}ms`;
  el.classList.add("is-revealed");
  el.addEventListener("transitionend", () => cleanup(el), { once: true });
  // Fallback in case transitionend doesn't fire (interrupted, no transition, etc.)
  setTimeout(() => cleanup(el), delay + 900);
}

export function initReveal(root = document) {
  const els = root.querySelectorAll("[data-reveal]:not([data-reveal-bound])");
  if (!els.length) return;

  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (reduce || !("IntersectionObserver" in window)) {
    // Show immediately and strip the hooks (no motion, hover transforms stay free).
    els.forEach((el) => cleanup(el));
    return;
  }

  const io = new IntersectionObserver((entries, obs) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      reveal(entry.target);
      obs.unobserve(entry.target);
    });
  }, { rootMargin: "0px 0px -10% 0px", threshold: 0.12 });

  els.forEach((el) => { el.setAttribute("data-reveal-bound", ""); io.observe(el); });
}
